import {useRouter} from 'next/router';
import {useEffect, useState} from 'react';

/**
 * Fix for
 * Error: Abort fetching component for route: "/"
 * @returns
 */
const useSafeReplaceLanguage = () => {
  const [onChanging, setOnChanging] = useState(false);
  const handleRouteChange = () => {
    setOnChanging(false);
  };
  const router = useRouter();
  const {asPath} = useRouter();

  // safeReplace is used to avoid route pushing errors when users click multiple times or when the network is slow:  "Error: Abort fetching component for route"
  const safeReplace = (language: string) => {
    if (onChanging) {
      return;
    }
    setOnChanging(true);
    router.replace(asPath, undefined, {locale: `${language}`});
  };

  useEffect(() => {
    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router, setOnChanging]);
  return {safeReplace};
};

export default useSafeReplaceLanguage;
